import React from 'react'
import { translations } from '../data/translations'

const Tabs = ({ activeView, handleViewChange, language, isAdmin }) => {
  const t = translations[language]
  const views = ['cards', 'locations', 'titles', 'bingo', 'articles']

  if (isAdmin) {
    views.push('editor')
  }

  return (
    <nav className="main-tabs" aria-label="Main tabs">
      {views.map((view) => (
        <button
          key={view}
          className={`tab ${activeView === view ? 'active' : ''}`}
          onClick={() => handleViewChange(view)}
          type="button"
        >
          {t.tabs[view]}
        </button>
      ))}
    </nav>
  )
}

export default Tabs
